import React, { Suspense, useState, useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Analytics from "./Analytics";
import Homepage from "../pages/v2/Homepage";
import NotFound from "../pages/v1/NotFound";
import Product from "../pages/v2/Product.jsx";
// import Test from "../pages/v2/Test.jsx"; // rota desativada — import removido para não inflar bundle
import searchListEvent from "../pages/v2/jsons/products_page_event.json";

const Products = React.lazy(() => import("../pages/v2/Products.jsx"));
const Search = React.lazy(() => import("../pages/v2/Search.jsx"));

const RouteFallback = () => (
  <div className="route-fallback" role="status" aria-live="polite" aria-label="Loading page">
    <div className="route-fallback-spinner" />
  </div>
);

const ProductSearchListLoader = ({ onNeedProducts }) => {
  const location = useLocation();

  useEffect(() => {
    if (["/view", "/search"].includes(location.pathname)) {
      onNeedProducts();
    }
  }, [location.pathname, onNeedProducts]);

  return null;
};

const App = () => {
  //lista de produtos (a ir buscar a outro ficheiro - ProductList.json)
  const [productSearchList, setProductSearchList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [isLoadingProducts, setIsLoadingProducts] = useState(true);
  const [productSearchListError, setProductSearchListError] = useState(false);
  const [tokenEvent, setTokenEvent] = useState([false]);
  const [expirationDate, setExpirationDate] = useState(null);
  const searchListRef = useRef(null);
  const productsPageFetchRef = useRef(null);

  //QUANDO ENTRA NESTE COMPONENTE
  useEffect(() => {
      checkToken()
  }, [tokenEvent]); 

  //Quando data expira
  useEffect(() => {
    if (expirationDate) {
      const now = new Date().getTime();
      const timeUntilExpiration = expirationDate - now;
   /*    console.log(timeUntilExpiration); */
      if (timeUntilExpiration > 0) {
       /*  console.log(timeUntilExpiration); */
        const timer = setTimeout(() => {
          // Aqui você executa a lógica que deseja quando a data de expiração for alcançada
        /*   console.log("A data de expiração foi alcançada."); */
          checkToken();
        }, timeUntilExpiration);

        return () => clearTimeout(timer); // Limpa o timer ao desmontar
      }
    }
  }, [expirationDate]);

  // Verifica se o item existe
  const checkToken = () => {
    const storedToken = JSON.parse(localStorage.getItem("authToken"));
    if (storedToken && isTokenValid(storedToken)) {
      // Token válido
      setProductSearchList(searchListEvent);
      const expirationDateToken = storedToken.expiration;
      setExpirationDate(expirationDateToken);
      /*  console.log("Token válido. Atualizando lista de produtos."); */
    } else if (storedToken && !isTokenValid(storedToken)) {
      // Token expirado
      setProductSearchList(searchListRef.current || []);
      setTokenEvent(false);
      setExpirationDate("");
      localStorage.removeItem("authToken");

      /* localStorage.removeItem("authToken"); */
      /*   console.log("Token expirado. Mantendo no localStorage."); */
    } else {
      // Token inexistente ou inválido
      setProductSearchList(searchListRef.current || []);
      setTokenEvent(false);
      /* setExpirationDate(""); */
      localStorage.removeItem("authToken");
      /*      localStorage.removeItem("authToken"); */
      /*     console.log(
        "Token inválido ou não encontrado. Removendo do localStorage."
      ); */
    }
  };

  // Função para verificar se o token está dentro do período válido
  const isTokenValid = React.useCallback((token) => {
    if (!token) return false;

    const now = new Date().getTime();
    const { startDate, expiration } = token;

    /*     // O token é válido apenas se estivermos entre a data de início e de expiração
      console.log("Agora:", now);
      console.log("Data de início:", startDate);
      console.log("Data de expiração:", expiration); */
    return now >= startDate && now < expiration;
  }, []);

  const loadProductSearchList = React.useCallback(() => {
    if (searchListRef.current) {
      const storedToken = JSON.parse(localStorage.getItem("authToken"));
      setProductSearchList(storedToken && isTokenValid(storedToken) ? searchListEvent : searchListRef.current);
      return productsPageFetchRef.current;
    }

    if (productsPageFetchRef.current) return productsPageFetchRef.current;

    setIsLoadingProducts(true);
    productsPageFetchRef.current = fetch('/products_page.json')
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        searchListRef.current = data;
        setProductSearchListError(false);
        const storedToken = JSON.parse(localStorage.getItem("authToken"));
        setProductSearchList(storedToken && isTokenValid(storedToken) ? searchListEvent : data);
        setIsLoadingProducts(false);
        return data;
      })
      .catch((err) => {
        console.error('[App] Erro ao carregar products_page.json:', err);
        setIsLoadingProducts(false);
        setProductSearchListError(true);
        productsPageFetchRef.current = null;
        return null;
      });

    return productsPageFetchRef.current;
  }, [isTokenValid]);

  const checkTokenEvent = (tokenevent, date) => {
    setTokenEvent(tokenevent);
    setExpirationDate(date);
  };

  const isValidRoute = (route) => {
    // Check if the route is one of the valid routes
    return ["/products", "/view", "/search", "/", "notfound"].includes(route);
  };

  return (
    <Suspense fallback={<RouteFallback />}>
      <Router scrollBehavior="auto">
        <Analytics />
        <ProductSearchListLoader onNeedProducts={loadProductSearchList} />
        <Routes>
          <Route path="/" index element={<Homepage />} />
           <Route
             path="/products"
             element={
               <Product
                 productList={productList}
                 productListEvent={searchListEvent}
                 hasTokenEvent={checkTokenEvent}
               />
             }
           />
           <Route
             path="/view"
             element={
               <Products
                 productList={productSearchList}
                 hasTokenEvent={checkTokenEvent}
                 isLoadingProducts={isLoadingProducts}
                  productListError={productSearchListError}
               />
             }
           />
           <Route
             path="/search"
             element={<Search productList={productSearchList} isLoadingProducts={isLoadingProducts} productListError={productSearchListError} />}
           />
          {/*   <Route path="/test" element={<Test />} /> */}
          <Route path="/error" element={<NotFound />} />
          <Route
            path="*"
            element={isValidRoute("*") ? null : <Navigate to="/" replace />}
          />
        </Routes>
      </Router>
    </Suspense>
  );
};

export default App;
